import React, { useState } from "react";
import { FaWhatsapp, FaTimes } from "react-icons/fa";

const WhatsAppButton = () => {
  const [open, setOpen] = useState(false);

  const phoneNumber = "918220057752"; // 🔁 replace
  const message = "Hi, I need help with CGR Mart";

  const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <>
      {/* ✅ Floating Button */}
      <div
        onClick={() => setOpen(!open)}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          backgroundColor: "#25D366",
          color: "#fff",
          borderRadius: "50%",
          width: "60px",
          height: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "28px",
          zIndex: 9999,
          cursor: "pointer",
          boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
        }}
      >
        {open ? <FaTimes /> : <FaWhatsapp />}
      </div>

      {/* ✅ Chat Popup */}
      {open && (
        <div
          style={{
            position: "fixed",
            bottom: "90px",
            right: "20px",
            width: "300px",
            backgroundColor: "#fff",
            borderRadius: "10px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
            zIndex: 9999,
            overflow: "hidden",
            fontFamily: "Arial",
          }}
        >
          {/* Header */}
          <div
            style={{
              backgroundColor: "#25D366",
              color: "#fff",
              padding: "10px",
              fontWeight: "bold",
            }}
          >
            Chat with us
          </div>

          {/* Message */}
          <div style={{ padding: "15px", fontSize: "14px" }}>
            👋 Hi there! <br />
            Need help? Chat with us on WhatsApp.
          </div>

          {/* Button */}
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "block",
              backgroundColor: "#25D366",
              color: "#fff",
              textAlign: "center",
              padding: "10px",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            Start Chat
          </a>
        </div>
      )}
    </>
  );
};

export default WhatsAppButton;